module.exports = __webpack_public_path__ + "img/best-pricing-p-500.bf5407d0.png";